import { vxm } from '@/stores';

export default (): void => {
  vxm.navigation.setLoading(false);
  window.scrollTo(0, 0);
};